import { init } from "@rematch/core";
import createRematchPersist from "@rematch/persist";

import * as models from "whiteboard/models";

const persistPlugin = createRematchPersist({
  whitelist: ["editor"],
  throttle: 1000,
  version: 1
});

const store = init({
  models,
  plugins: [persistPlugin]
});

export default store;
export const { dispatch } = store;



// WEBPACK FOOTER //
// ./src/whiteboard/AppStore.js